import { createSelector } from "reselect";
import { selectCreateShipmentMeta } from "./selectCreateShipmentMeta";

export const selectCurrentStep = createSelector(
  selectCreateShipmentMeta,
  ({ stepStack }) => stepStack[stepStack.length - 1]
);
